/**
 * Host labels and URL slugs that must never be assigned to an academy.
 * Covers platform infrastructure subdomains and common reserved names.
 */
export const RESERVED_ACADEMY_SLUGS = [
  'app',
  'www',
  'mail',
  'academy',
  'api',
  'dev',
  'staging',
  'auth',
  'admin',
  'backoffice',
  'support',
  'help',
  'status',
  'blog',
  'news',
  'cdn',
  'static',
  'assets',
  'ftp',
  'smtp',
  'pop',
  'imap',
  'ns1',
  'ns2',
  'mx',
  'localhost',
  'app-dev',
  'mail-dev',
  'academy-dev',
  'club-academy',
  'settings',
  'organization',
] as const;

export type ReservedAcademySlug = (typeof RESERVED_ACADEMY_SLUGS)[number];

const RESERVED_SET = new Set<string>(RESERVED_ACADEMY_SLUGS);

export function isReservedAcademySlug(value: string): boolean {
  return RESERVED_SET.has(value.trim().toLowerCase());
}
